import './LoginWindow.scss';
import React from 'react';
import LoginComponent from '../LoginForms/LoginComponent';

const LoginWindow = (props) => {
  return (
    <div className="App widget-styles">
      <LoginComponent
        userEmailAddress={props.userEmailAddress}
        authorisedEmail={props.authorisedEmail}
        subjectEmail={props.subjectEmail}
        onSubmitDSRModelForm={props.onSubmitDSRModelForm}
        onSubmitotpEmail={props.onSubmitotpEmail}
        backToPage={props.backToPage}
        loginURL={props.loginURL}
        pageUrl={props.pageUrl}
        isFrom={props.isFrom}
        t={props.t}
      />
    </div>
  );
};

export default LoginWindow;
